import template from './edit_transaction_type.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EditTransactionTypeViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.transaction_types = ko.observableArray();
		this.transaction_type_id = ko.observable();
		this.company_id = ko.observable();
		this.description = ko.observable();
		this.id = ko.observable(null);
	}

	async save_transaction_type()
	{
		//validation
		if (!this.transaction_type_id())
		{
			Grape.alerts.alert({type: 'error', message: tr('Please select a transaction type'), title: tr('Error', 'Error')});
			return;
		}

		if (!this.description())
		{
			Grape.alerts.alert({type: 'error', message: tr('Please enter a description'), title: tr('Error', 'Error')});
			return;
		}

		var data = {
			id: this.id(),
			transaction_type_id: this.transaction_type_id(),
			description: this.description(),
			company_id: this.company_id(),
		};

		let res = await Grape.fetches.postJSON('/payroll_integration/user_transaction_type_upsert', data);
		if (res.status == 'OK') {
			await Grape.alerts.alert({type: 'success', message: tr('Successfully saved transaction type.'), title: tr('Success', 'Success')});
			this.dialog.close();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else 
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...' ), title: tr('Error', 'Error')});
	};

	close()
	{
		this.dialog.close();
	}
};

class EditTransactionTypePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EditTransactionTypeViewModel(this);
	}
	
	async init()
	{
		//edit mode
		if (this.bindings?.company_id)
			this.viewModel.company_id(this.bindings.company_id);
		else
			this.close();

		await this.get_transaction_types().then(() => {

			if (this.bindings.payrollDescription) {
				let matchingTransactionType = ko.utils.arrayFirst(
					this.viewModel.transaction_types(),
					(a) => {
						return (
							a.description === this.bindings.payrollDescription
						);
					}
				);

				// If a matching transaction type is found, set it as the value of the <select> element
				if (matchingTransactionType) {
					this.viewModel.transaction_type_id(
						matchingTransactionType.transaction_type_id
					);
				}
			}
		});

		if (this.bindings.user_description)
			this.viewModel.description(this.bindings.user_description);

		if (this.bindings.id)
			this.viewModel.id(this.bindings.id);
	};

	async get_transaction_types()
	{
		//get all the employees
		let filter = [{
				value: this.viewModel.company_id(),
				op: '=',
				field: 'company_id',
			},
			{
				value: 'true', op: '=', field: 'active' 
			}];

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'transaction_type_payroll_sync',
			schema: 'public',
			limit: 1000000,
			filter: filter,
		});
		if (res.records != null)
			this.viewModel.transaction_types(res.records);
	};
};

export default {
	name: 'EditTransactionType',
	dialog_class: EditTransactionTypePage,
	template: template,
	template_filename: 'translation/dialogs/edit_transaction_type',
	provider: 'ps'
};